import styled from "styled-components";
import {Person, StyledBaseProps} from "@betrue/shared/interfaces";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField
} from "@mui/material";
import * as React from "react";
import {useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {AddUserProps} from "./add-user";
import {userFormValidationSchema, UserModalForm} from "./add-user.form";

interface AddUserViewProps extends StyledBaseProps, AddUserProps {
  onOpenModal: () => void,
  onCloseModal: () => void,
  onSubmit: (form: UserModalForm) => void
  isOpen: boolean
  enabled: boolean
  currentPerson: Person
}

export const AddUserView = styled((props: AddUserViewProps) => {
  const {register, handleSubmit, control, formState: {errors}, reset} = useForm<UserModalForm>({
    resolver: yupResolver(userFormValidationSchema),
  })

  const [quoteFile, setUserFile] = useState(undefined)

  return (
    <div className={props.className}>
      <Grid container spacing={3}>
        <Grid item>
          <Button disabled={!props.enabled} variant={"outlined"} color={"primary"} onClick={props.onOpenModal}>
            {props.openModalLabel}
          </Button>
        </Grid>
      </Grid>
      <Dialog
        disableAutoFocus={true}
        disableEnforceFocus={true}
        disableRestoreFocus={true}
        disablePortal={true}
        open={props.isOpen}
        onClose={() => {
          props.onCloseModal()
          reset({})
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <form onSubmit={handleSubmit(props.onSubmit)}>

          <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {props.dialogDescription}
            </DialogContentText>

            <Grid container spacing={2}
                  direction={"row"}
                  alignContent={"center"}
                  justifyContent={"center"}
                  alignItems={"center"}>
              <Grid item xs={12}>
                <Controller
                  defaultValue=""
                  name={"firstName"}
                  render={({field, fieldState, formState}) => (
                    <TextField
                      {...field}
                      label={props.firstNameLabel}
                      helperText={fieldState.error?.message}
                      error={!!(fieldState.invalid)}
                      fullWidth/>)
                  }
                  control={control}/>
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name={"lastName"}
                  defaultValue=""
                  render={({field, fieldState, formState}) => (
                    <TextField
                      {...field}
                      label={props.lastNameLabel}
                      helperText={fieldState.error?.message}
                      error={!!(fieldState.invalid)}
                      fullWidth/>)
                  }
                  control={control}/>
              </Grid>
              <Grid item xs={12}>
                <Controller
                  defaultValue=""

                  name={"email"}
                  render={({field, fieldState, formState}) => (
                    <TextField
                      {...field}
                      label={props.emailLabel}
                      type={"email"}
                      helperText={fieldState.error?.message}
                      error={!!(fieldState.invalid)}
                      fullWidth/>)
                  }
                  control={control}/>
              </Grid>

            </Grid>
          </DialogContent>
          <DialogActions>
            <Button color="secondary" onClick={() => {
              props.onCloseModal()
              reset({})
            }}>
              {props.dialogCancel ? props.dialogCancel : 'Annuler'}
            </Button>
            <Button autoFocus color="primary" type={"submit"}>
              {props.dialogSubmit ? props.dialogSubmit : 'Valider'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>)
})`
  & .bt-drop-zone {
    flex: 1;
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: #eeeeee;
    border-style: dashed;
    background-color: #fafafa;
    color: #bdbdbd;
    outline: none;
    transition: border .24s ease-in-out;
  }

  & .bt-drop-zone:focus {
    border-color: #2196f3;
  }

`
